import { render, staticRenderFns } from "./iconUngroup.vue?vue&type=template&id=ea051046"
import script from "./iconUngroup.vue?vue&type=script&lang=js"
export * from "./iconUngroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports